export function notEmpty<T>(value: null | T | undefined): value is T {
  if (value === null || value === undefined) return false;
  return true;
}

export const arrayEquality = <T>(newValue: null | T[] | undefined, value: null | T[] | undefined) =>
  Boolean(value?.length === newValue?.length && value?.every((val, i) => val === newValue?.[Number(i)]));
